import { Button, CircularProgress, Tab, Tabs, Link, Dialog, DialogContent, DialogActions, Container, Grid } from '@mui/material'
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import * as Yup from 'yup';
import Logo from '../components/common/Logo';
import { useSelector, shallowEqual } from 'react-redux';
import { getUserId } from '../util'
import TextInput from '../components/common/TextInput'
import PageContainer from '../components/PageContainer'
import { signInUser } from '../redux/actions/userActions';
import { changePassword } from '../redux/api/system';
import PasswordTextInput from '../components/common/PasswordTextInput'

const PasswordReset = ({ signInUser }) => {
    const md = useMediaQuery({ query: '(min-width: 1200px)' })
    const history = useHistory()
    const { enqueueSnackbar } = useSnackbar();
    const [ resetAlert, setResetAlert ] = useState(false);

    const userInfo = useSelector((state) => state, shallowEqual);

    const resetLogin = async (values, { resetForm }) => {
      let payload = values;
      // delete payload.confirm
      // payload.userid = userInfo?.user?.userData?.user_data?.userID || values.userid
        try {
            const res = await changePassword({ userid: values.userid, password: values.password, newpassword: values.newpassword  })
            if(res.responseCode == "00"){
                setResetAlert(true)
            }
            else{
                enqueueSnackbar(res?.message || res?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }


    const FormSchema = Yup.object().shape({
      newpassword: Yup
        .string()
        .min(8, 'Password must be 8 characters long')
        .matches(/[0-9]/, 'Password requires a number')
        .matches(/[a-z]/, 'Password requires a lowercase letter')
        .matches(/[A-Z]/, 'Password requires an uppercase letter')
        .matches(/[^\w]/, 'Password requires a symbol'),
      confirm: Yup
        .string()
        .oneOf([Yup.ref('newpassword'), null], 'Must match "New Password" field value'),
    });

    return (
        <section style={{ minHeight: '50vh' }}>
            <Grid container
                style={{ 
                    minHeight: '100vh',
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/img/bg/group.jpg'})`, 
                    backgroundRepeat: 'no-repeat', 
                    backgroundSize: 'cover' 
                }}
                
            >
                <Grid item xs={0} sm={0} lg={8} md={6} style={{ background: 'rgba(0, 0, 0, 0.25)' }}
                >
                    
                </Grid>
                <Grid item lg={4} md={6} xs={12} sm={12} style={{ background: 'rgba(255,255,255,0.97)' }}>
                    <Formik
                      initialValues={{ userid: '', password: '', newpassword: '', confirm: '' }}
                      onSubmit={resetLogin}
                      validationSchema={FormSchema}
                    >
                        {
                          ({ handleChange, isSubmitting  }) => (
                            <Form style={{ display: 'flex', justifyContent: 'center', padding: '4rem' }}>
                              <Grid container spacing={3}>
                                <Grid item xs={12} container justifyContent={'center'} alignItems='center'>
                                  <Logo />
                                </Grid>
                                <Grid item xs={12} container justifyContent={'center'} alignItems='center'>
                                  <Tabs value={0} centered>
                                    <Tab label="Password Reset" />
                                  </Tabs>
                                </Grid>
                                
                                <Grid item xs={12} container spacing={3}>
                                  <Grid item xs={12}>
                                      <TextInput id="userid" label="User ID" readonly required />
                                  </Grid>
                                  <Grid item xs={12}>
                                      <TextInput id="password" label="Password" type="password" required />
                                  </Grid>
                                  <Grid item xs={12}>
                                      <PasswordTextInput id="newpassword" label="New Password" type="password" required />
                                  </Grid>
                                  <Grid item xs={12}>
                                      <PasswordTextInput id="confirm" label="Confirm Password" type="password" required />
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Button variant="contained" type='submit' disabled={isSubmitting} fullWidth>
                                        { isSubmitting ? <CircularProgress size={15} color='inherit' /> : 'Login' }
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Form>
                          )
                        }
                    </Formik>
                </Grid>
            </Grid>
            <Dialog
                open={Boolean(resetAlert)}
                keepMounted
                disableEscapeKeyDown
            >
                <DialogContent>
                    
                    <h2 className='mb-0 mt-0'>Password Reset Successfully</h2>
                    <p className='mt-05'> You will be redirected to the login page.</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setResetAlert(false); history.push('/login') }} variant='contained' color='success'>Ok</Button>
                </DialogActions>
            </Dialog>
        </section>
    )
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ signInUser },dispatch)
}

export default connect(({ user }) => ({ user }), mapDispatchToProps)(PasswordReset)